import * as $ from 'jquery';

export default (function () {
  $('#chat-sidebar-toggle').on('click', e => {
    $('#chat-sidebar').toggleClass('open');
    e.preventDefault();
  });
}())



// WEBPACK FOOTER //
// ./resources/assets/js/chat/index.js